export const translations = {
  en: {
    // Page title
    "page-title": "OpenWES | Smart Warehouse Execution System",

    // Navigation
    "nav.logo": "OpenWES",
    "nav.features": "Features",
    "nav.solutions": "Solutions",
    "nav.pricing": "Pricing",
    "nav.resources": "Resources",
    "nav.contact": "Contact",
    "nav.login": "Login",

    // Hero section
    "hero.title": "Optimize Your Warehouse Operations",
    "hero.subtitle": "Our advanced Warehouse Execution System (WES) combines real-time visibility, intelligent automation, and data-driven insights to maximize your warehouse efficiency and throughput.",
    "hero.demoBtn": "Request Demo",
    "hero.pricingBtn": "View Plans",

    // Features section
    "features.title": "Powerful Warehouse Execution Features",
    "features.subtitle": "Designed to streamline operations, reduce costs, and improve accuracy across your entire warehouse ecosystem.",
    "features.1.title": "Automated Task Management",
    "features.1.desc": "Intelligently assigns and prioritizes tasks to workers and equipment in real-time for optimal workflow.",
    "features.2.title": "Real-time Analytics",
    "features.2.desc": "Gain actionable insights with customizable dashboards and performance metrics.",
    "features.3.title": "Seamless Integration",
    "features.3.desc": "Connects effortlessly with your existing WMS, ERP, and automation systems.",
    "features.4.title": "Inventory Optimization",
    "features.4.desc": "Dynamic slotting and putaway strategies to maximize space utilization.",
    "features.5.title": "Labor Management",
    "features.5.desc": "Track productivity, assign tasks based on skill, and optimize workforce utilization.",
    "features.6.title": "Multi-carrier Shipping",
    "features.6.desc": "Automated carrier selection, label printing, and manifest generation.",

    // Dashboard section
    "dashboard.title": "Real-time Warehouse Control",
    "dashboard.subtitle": "Our intuitive dashboard gives you complete visibility and control over all warehouse operations from a single pane of glass.",
    "dashboard.features.1": "Monitor all warehouse activities in real-time",
    "dashboard.features.2": "Identify bottlenecks before they impact operations",
    "dashboard.features.3": "Make data-driven decisions with comprehensive reporting",
    "dashboard.features.4": "Customizable views for different user roles",
    "dashboard.cta": "See it in Action",

    // Testimonials
    "testimonials.title": "Trusted by Leading Warehouses",
    "testimonials.subtitle": "Don't just take our word for it. Here's what our customers say about OpenWES.",
    "testimonials.1.quote": "\"OpenWES transformed our operations. We've seen a 35% increase in productivity and a 20% reduction in labor costs within the first three months.\"",
    "testimonials.1.name": "John Smith",
    "testimonials.1.position": "Operations Director, MegaDistro",
    "testimonials.2.quote": "\"The real-time visibility and automated task management have been game-changers for our fulfillment center. Our order accuracy is now at 99.9%.\"",
    "testimonials.2.name": "Sarah Johnson",
    "testimonials.2.position": "Warehouse Manager, QuickShip",
    "testimonials.3.quote": "\"Implementation was seamless, and the support team was fantastic. OpenWES pays for itself in efficiency gains alone.\"",
    "testimonials.3.name": "Michael Chen",
    "testimonials.3.position": "COO, Global Logistics Inc.",

    // Pricing
    "pricing.comingSoon": "Coming Soon",
    "pricing.title": "Simple and Transparent Pricing",
    "pricing.subtitle": "Choose the plan that fits your warehouse needs. Scale flexibly as your business grows.",
    "pricing.month": "/month",
    "pricing.featured": "Most Popular",
    "pricing.0.plan": "Free",
    "pricing.0.features.1": "Up to 10 users",
    "pricing.0.features.2": "Basic task management",
    "pricing.0.features.3": "1 warehouse supported",
    "pricing.0.features.4": "1000 daily orders",
    "pricing.1.plan": "Starter",
    "pricing.1.features.1": "Up to 50 users",
    "pricing.1.features.2": "Basic task management",
    "pricing.1.features.3": "Standard reporting",
    "pricing.1.features.4": "Email support",
    "pricing.1.features.5": "Up to 3 warehouses supported",
    "pricing.1.features.6": "10,000 daily orders",
    "pricing.2.plan": "Professional",
    "pricing.2.features.1": "Up to 100 users",
    "pricing.2.features.2": "Advanced automation",
    "pricing.2.features.3": "Custom reports",
    "pricing.2.features.4": "Priority support",
    "pricing.2.features.5": "Up to 5 warehouses supported",
    "pricing.2.features.6": "API access",
    "pricing.2.features.7": "100,000 daily orders",
    "pricing.3.plan": "Enterprise",
    "pricing.3.price": "Custom",
    "pricing.3.features.1": "Unlimited users",
    "pricing.3.features.2": "Full automation suite",
    "pricing.3.features.3": "Advanced analytics",
    "pricing.3.features.4": "24/7 dedicated support",
    "pricing.3.features.5": "Unlimited locations",
    "pricing.3.features.6": "Custom integrations",
    "pricing.3.features.7": "Unlimited orders",
    "pricing.cta": "Get Started",
    "pricing.contact": "Contact Sales",

    // CTA
    "cta.title": "Ready to Transform Your Warehouse Operations?",
    "cta.subtitle": "Join hundreds of warehouses that are already optimizing their operations with OpenWES.",
    "cta.cta": "Request a Demo",

    // Footer
    "footer.company": "OpenWES",
    "footer.description": "The most advanced Warehouse Execution System for modern distribution centers and fulfillment operations.",
    "footer.product": "Product",
    "footer.integrations": "Integrations",
    "footer.updates": "Updates",
    "footer.roadmap": "Roadmap",
    "footer.resources": "Resources",
    "footer.blog": "Blog",
    "footer.guides": "Guides",
    "footer.webinars": "Webinars",
    "footer.help": "Help Center",
    "footer.api": "API Docs",
    "footer.companyMenu": "Company",
    "footer.about": "About Us",
    "footer.careers": "Careers",
    "footer.partners": "Partners",
    "footer.press": "Press",
    "footer.copyright": "2023 OpenWES Technologies. All rights reserved.",
    "footer.privacy": "Privacy Policy",
    "footer.terms": "Terms of Service",

    "form.title": "Contact Us",
    "form.subtitle": "Fill out the form below and our team will get back to you shortly.",
    "form.name": "Full Name",
    "form.email": "Email Address",
    "form.company": "Company Name",
    "form.phone": "Phone Number",
    "form.message": "Your Message",
    "form.submit": "Submit Request",
    "form.success": "Thank you! We'll contact you soon.",

    "form.firstName": "First Name",
    "form.lastName": "Last Name",
    "form.tenantName": "Company/Organization Name",
    "form.apply.success": "Application submitted successfully! The System messages will sent to your email when system set up.",

    "form.error": "Error submitting application. Please try again."
  },
  zh: {
    // Page title
    "page-title": "OpenWES | 智能仓库执行系统",

    // Navigation
    "nav.logo": "OpenWES",
    "nav.features": "功能特点",
    "nav.solutions": "解决方案",
    "nav.pricing": "价格方案",
    "nav.resources": "资源中心",
    "nav.contact": "联系我们",
    "nav.login": "登录",

    // Hero section
    "hero.title": "优化您的仓储运营效率",
    "hero.subtitle": "我们先进的仓库执行系统(WES)结合实时可视化、智能自动化和数据驱动的洞察力，最大化您的仓库效率和吞吐量。",
    "hero.demoBtn": "申请演示",
    "hero.pricingBtn": "查看方案",

    // Features section
    "features.title": "强大的仓库执行功能",
    "features.subtitle": "专为简化操作、降低成本并提高整个仓库生态系统的准确性而设计。",
    "features.1.title": "自动化任务管理",
    "features.1.desc": "智能实时分配和优先处理工人和设备任务，实现最佳工作流程。",
    "features.2.title": "实时分析",
    "features.2.desc": "通过可定制的仪表板和性能指标获得可操作的洞察。",
    "features.3.title": "无缝集成",
    "features.3.desc": "轻松与您现有的WMS、ERP和自动化系统连接。",
    "features.4.title": "库存优化",
    "features.4.desc": "动态货位分配和上架策略，最大化空间利用率。",
    "features.5.title": "劳动力管理",
    "features.5.desc": "跟踪生产力，根据技能分配任务，优化劳动力利用率。",
    "features.6.title": "多承运商运输",
    "features.6.desc": "自动承运商选择、标签打印和清单生成。",

    // Dashboard section
    "dashboard.title": "实时仓库控制",
    "dashboard.subtitle": "我们直观的仪表板让您从一个界面全面了解和掌控所有仓库操作。",
    "dashboard.features.1": "实时监控所有仓库活动",
    "dashboard.features.2": "在瓶颈影响运营前识别它们",
    "dashboard.features.3": "通过全面的报告做出数据驱动的决策",
    "dashboard.features.4": "为不同用户角色定制视图",
    "dashboard.cta": "查看实际效果",

    // Testimonials
    "testimonials.title": "领先仓库的信赖之选",
    "testimonials.subtitle": "不仅仅是我们的承诺，以下是客户对OpenWES的评价。",
    "testimonials.1.quote": "\"OpenWES彻底改变了我们的运营。在前三个月内，我们看到了35%的生产力提升和20%的劳动力成本降低。\"",
    "testimonials.1.name": "张伟",
    "testimonials.1.position": "运营总监，大仓配",
    "testimonials.2.quote": "\"实时可视化和自动化任务管理为我们的配送中心带来了革命性变化。我们的订单准确率现在达到99.9%。\"",
    "testimonials.2.name": "李娜",
    "testimonials.2.position": "仓库经理，快运达",
    "testimonials.3.quote": "\"实施过程非常顺利，支持团队非常出色。仅凭效率提升，OpenWES就物有所值。\"",
    "testimonials.3.name": "陈明",
    "testimonials.3.position": "首席运营官，全球物流",

    // Pricing
    "pricing.comingSoon": "敬请期待",
    "pricing.title": "简单透明的定价",
    "pricing.subtitle": "选择适合您仓库需求的方案。随着业务发展灵活调整。",
    "pricing.month": "/月",
    "pricing.featured": "最受欢迎",
    "pricing.0.plan": "免费使用",
    "pricing.0.features.1": "最多10个用户",
    "pricing.0.features.2": "基本任务管理",
    "pricing.0.features.3": "支持1个仓库",
    "pricing.0.features.4": "每日订单数量1000",
    "pricing.1.plan": "入门版",
    "pricing.1.features.1": "最多50个用户",
    "pricing.1.features.2": "基本任务管理",
    "pricing.1.features.4": "邮件支持",
    "pricing.1.features.5": "支持最多3个仓库",
    "pricing.1.features.6": "每日订单数量10000",
    "pricing.2.plan": "专业版",
    "pricing.2.features.1": "最多100个用户",
    "pricing.2.features.2": "高级自动化",
    "pricing.2.features.3": "定制报告",
    "pricing.2.features.4": "优先支持",
    "pricing.2.features.5": "支持最多5个仓库",
    "pricing.2.features.6": "API访问",
    "pricing.2.features.7": "每日订单数量100000",
    "pricing.3.plan": "企业版",
    "pricing.3.price": "定制",
    "pricing.3.features.1": "无限制用户",
    "pricing.3.features.2": "全套自动化功能",
    "pricing.3.features.3": "高级分析",
    "pricing.3.features.4": "24/7专属支持",
    "pricing.3.features.5": "无限制仓库",
    "pricing.3.features.6": "定制集成",
    "pricing.3.features.7": "订单数量无限制",
    "pricing.3.features.8": "私有化部署",
    "pricing.cta": "立即开始",
    "pricing.contact": "联系销售",

    // CTA
    "cta.title": "准备好改变您的仓储运营了吗？",
    "cta.subtitle": "加入数百家已经使用OpenWES优化运营的仓库行列。",
    "cta.cta": "申请演示",

    // Footer
    "footer.company": "OpenWES",
    "footer.description": "面向现代配送中心和履约操作的最先进仓库执行系统。",
    "footer.product": "产品",
    "footer.integrations": "集成",
    "footer.updates": "更新",
    "footer.roadmap": "路线图",
    "footer.resources": "资源",
    "footer.blog": "博客",
    "footer.guides": "指南",
    "footer.webinars": "网络研讨会",
    "footer.help": "帮助中心",
    "footer.api": "API文档",
    "footer.companyMenu": "公司",
    "footer.about": "关于我们",
    "footer.careers": "职业发展",
    "footer.partners": "合作伙伴",
    "footer.press": "新闻",
    "footer.copyright": "2025 OpenWES 版权所有",
    "footer.privacy": "隐私政策",
    "footer.terms": "服务条款",

    "form.title": "联系我们",
    "form.subtitle": "填写下方表格，我们的团队会尽快与您联系。",
    "form.name": "姓名",
    "form.email": "电子邮箱",
    "form.company": "公司名称",
    "form.phone": "电话号码",
    "form.message": "您的留言",
    "form.submit": "提交请求",
    "form.success": "感谢您的联系！我们会尽快与您联系。",

    "form.firstName": "名字",
    "form.lastName": "姓氏",
    "form.tenantName": "公司/组织名称",
    "form.employees": "员工人数",
    "form.apply.success": "申请提交成功！系统完成初始化之后会将信息发送到您的邮箱，请注意查收",
    "form.error": "提交申请时出错，请重试"
    }
};
